// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});



//////////////////
// WEBPACK FOOTER
// /Users/chad/Developer/shelfmaid-abel/site/~/core-js/modules/es6.reflect.set-prototype-of.js
// module id = ../../../../core-js/modules/es6.reflect.set-prototype-of.js
// module chunks = 0